export * from './WithFaceDescriptor';
export * from './WithFaceDetection';
export * from './WithFaceExpressions';
export * from './WithFaceLandmarks';
export * from './WithAge';
export * from './WithGender';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/factories/index.js
// module id = 1063
// module chunks = 0